<template>
  <div
    :class="wrapperClass"
    v-infinite-scroll="!isEmpty && loadMore"
    :infinite-scroll-disabled="loading"
    :infinite-scroll-distance="scrollDistance"
  >
    <slot name="default"></slot>
    <div :class="`empty-box ${emptyBoxClass}`" v-if="isEmpty">
      <slot name="empty-box">
        <b-img-lazy
          class="empty-box__image width-181 margin-bottom-21"
          :src="generateEmptyImage"
        />
        <div class="empty-box__text color-complementary-300 font-size-14">
          {{ generateEmptyText }}
        </div>
      </slot>
    </div>
    <div v-if="loading" class="lazy-loading">
      <mdicon name="loading" size="24" class="spinner" />
    </div>
  </div>
</template>

<script>
import infiniteScroll from "vue-infinite-scroll";

export default {
  props: {
    wrapperClass: {
      type: String,
      default: "",
    },
    emptyBoxClass: {
      type: String,
      default: "",
    },
    scrollDistance: {
      type: String,
      default: "2000",
    },
    loadMore: {
      type: Function,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isEmpty: {
      type: Boolean,
      default: false,
    },
    emptyImage: {
      type: String,
      default: "",
    },
    emptyText: {
      type: String,
      default: "",
    },
  },
  directives: { infiniteScroll },
  computed: {
    generateEmptyImage() {
      return this.emptyImage || this.$config.images.shared.redesign.empty.list;
    },
    generateEmptyText() {
      return this.emptyText || this.$lang.list_empty_text;
    },
  },
};
</script>
